module.exports = __webpack_public_path__ + "static/media/close.0c4694e7.svg";